export const ApplicationClaim = 1; // User logged in and has access to the application.
export const TokenEmailAddress = 'token@lsq.com';
export const TestEmailAddress = 'test@lsq.com';
